import React, { useState, useEffect, Fragment, useCallback } from "react";
import { ReactComponent as PhoneIcon } from "../../icons/phoneIcon.svg";
import { ReactComponent as MailIcon } from "../../icons/mailIcon.svg";
import { ReactComponent as LocIcon } from "../../icons/locIcon.svg";
import "./ContactUs.css";
import { useDispatch, useSelector } from "react-redux";
import { createContactUsForm, clearErrors } from "../../actions/formAction";
import { NEW_CONTACTUS_RESET } from "../../constants/formsConstants";
import { useHistory } from "react-router-dom";
import Loader from "../layout/Loader/Loader";

const ContactUs = () => {
  const [contactUsFormData, setContactUsFormData] = useState({
    fnameContactUs: "",
    mobileNumberContactUs: "",
    emailContactUs: "",
    cityContactUs: "",
    ContactUsInfo: "",
    // Add more form fields as needed
  });

  const [isContactFormValid, setIsContactFormValid] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const pattern = /^[6-9][0-9]{0,20}$/;

  const { loading, error, success } = useSelector((state) => state.contact);

  // Function to update form data
  const handleContactUsInputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    if (name === "mobileNumberContactUs" && value && !pattern.test(value)) {
      // If the input value does not match the pattern, do not update the state
      e.target.value = "";
      setPhoneError(true);
    } else if (
      name === "mobileNumberContactUs" &&
      value &&
      pattern.test(value)
    ) {
      // If the input value matches the pattern, update the state
      e.target.value = value;
      setPhoneError(false);
    }
    if (name === "mobileNumberContactUs" && value.length >= 10) {
      const truncatedValueF = value.slice(0, 10);
      e.target.value = truncatedValueF;
      setContactUsFormData((prevData) => ({
        ...prevData,
        [name]: truncatedValueF,
      }));
    } else {
      setContactUsFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const validateContactForm = useCallback(() => {
    const { fnameContactUs, mobileNumberContactUs } = contactUsFormData;
    const requiredFields = [fnameContactUs, mobileNumberContactUs];

    return (
      requiredFields.every((field) => field.trim() !== "") &&
      mobileNumberContactUs.length === 10 &&
      !phoneError &&
      pattern.test(contactUsFormData.mobileNumberContactUs)
    );
  }, [contactUsFormData]);

  // Update form validity whenever the form data changes
  useEffect(() => {
    if (error) {
      dispatch(clearErrors());
    }

    if (success) {
      dispatch({ type: NEW_CONTACTUS_RESET });
    }
    setIsContactFormValid(validateContactForm());
  }, [contactUsFormData, dispatch, error, success, validateContactForm]);

  const handleContactUsSubmit = (e) => {
    e.preventDefault();

    if (validateContactForm) {
      const myForm = new FormData();

      myForm.set("name", contactUsFormData.fnameContactUs);
      myForm.set("phone", contactUsFormData.mobileNumberContactUs);
      myForm.set("email", contactUsFormData.emailContactUs);
      myForm.set("city", contactUsFormData.cityContactUs);
      myForm.set("info", contactUsFormData.ContactUsInfo);

      dispatch(createContactUsForm(myForm)).then(() => {
        history.push("/formSubmit");
      });
    } else {
      alert("Form not valid");
    }
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div>
            <div className="contact-us-page">
              <div className="contact-info">
                <p className="cont-info">CONTACT INFORMATION</p>
                <p className="contact-1">
                  <PhoneIcon className="contact-icons" />
                  <span>+91 8000 8111 60</span>
                </p>
                <p className="contact-1">
                  <MailIcon className="contact-icons" />
                  <span>contact@zoplar.com</span>
                </p>
                <p className="contact-1">
                  <LocIcon className="contact-icons" />
                  {/* <Link> */}
                  <span>
                    201-205, 2nd Floor,
                    M3M Cosmopolitan, <br/>
                    Sector 66,Gurugram, Haryana - 122002
                  </span>
                  {/* </Link> */}
                </p>
                <p className="contact-1">
                <svg className="contact-icons" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 122.88 101.9" style={{ enableBackground: 'new 0 0 122.88 101.9', fill: '#ffffff'}} xmlSpace="preserve">
                <g>
      <path className="st0" d="M3.34,0h116.2c1.84,0,3.34,1.5,3.34,3.34v76.98c0,1.84-1.5,3.34-3.34,3.34H3.34C1.5,83.66,0,82.16,0,80.32V3.34C0,1.5,1.5,0,3.34,0L3.34,0L3.34,0L3.34,0z M81.7,67.73L65.64,58v-6.17L81.7,42.1v7.33l-9.76,5.5l9.76,5.5V67.73L81.7,67.73L81.7,67.73z M91.67,67.73L107.73,58v-6.17L91.67,42.1v7.33l9.76,5.5l-9.76,5.5V67.73L91.67,67.73L91.67,67.73z M38.64,43.98l3.83,3.83c1.01,1.01,1.01,2.66,0,3.66l-3.08,3.08c0.85,1.59,1.5,3.3,1.91,5.1h3.99c1.42,0,2.59,1.17,2.59,2.59v5.41c0,1.42-1.17,2.59-2.59,2.59h-4.36c-0.39,1.28-0.89,2.5-1.51,3.66h75.51c1.62,0,2.95-1.33,2.95-2.95V8.19c0-1.62-1.32-2.95-2.95-2.95H7.96l0,0l0,0C6.33,5.24,5,6.57,5.01,8.19l0,34.61c1.01-0.79,2.5-0.73,3.42,0.21l3.08,3.08c1.59-0.85,3.3-1.5,5.1-1.91v-3.99c0-1.42,1.17-2.58,2.59-2.58h5.41c1.42,0,2.59,1.17,2.59,2.59v4.35c1.76,0.54,3.43,1.3,4.95,2.26l2.82-2.83C35.99,42.97,37.63,42.97,38.64,43.98L38.64,43.98L38.64,43.98L38.64,43.98z M21.22,52.3c6.6,0,11.95,5.35,11.95,11.96c0,3.96-1.92,7.47-4.89,9.64H14.16c-2.97-2.17-4.89-5.68-4.89-9.64C9.27,57.65,14.62,52.3,21.22,52.3L21.22,52.3L21.22,52.3L21.22,52.3z M13.65,24.25h7.67c0.59,0,1.07,0.5,1.07,1.07v2.18c0,0.58-0.5,1.07-1.07,1.07h-7.67c-0.58,0-1.07-0.48-1.07-1.07v-2.18C12.57,24.73,13.05,24.25,13.65,24.25L13.65,24.25z M26.35,13.12h29.68c0.59,0,1.07,0.49,1.07,1.07v2.18c0,0.59-0.49,1.07-1.07,1.07H26.35c-0.59,0-1.07-0.48-1.07-1.07v-2.18C25.28,13.6,25.76,13.12,26.35,13.12L26.35,13.12z M13.65,13.12h7.67c0.59,0,1.07,0.48,1.07,1.07v2.18c0,0.59-0.48,1.07-1.07,1.07h-7.67c-0.59,0-1.07-0.48-1.07-1.07v-2.18C12.57,13.6,13.05,13.12,13.65,13.12L13.65,13.12z M38.36,24.25h49.25c0.59,0,1.07,0.5,1.07,1.07v2.18c0,0.57-0.5,1.07-1.07,1.07H38.36c-0.58,0-1.07-0.48-1.07-1.07v-2.18C37.29,24.73,37.77,24.25,38.36,24.25L38.36,24.25z M26.21,24.25h7.67c0.59,0,1.07,0.5,1.07,1.07v2.18c0,0.58-0.5,1.07-1.07,1.07h-7.67c-0.58,0-1.07-0.48-1.07-1.07v-2.18C25.13,24.73,25.62,24.25,26.21,24.25L26.21,24.25z M46.29,88.27h30.3c0.08,5.24,2.24,9.93,8.09,13.63H38.2C42.88,98.51,46.31,94.39,46.29,88.27L46.29,88.27L46.29,88.27L46.29,88.27z"/>
    </g>
  </svg>
          <span>
         IT Grievance Officer  <br />
          Mr. Arshil Naqvi, 
          arshil@zoplar.com
        </span>
      </p>

                 
                <p style={{paddingLeft:'25px'}}  className="contact-1">SAVDO TECHNOLOGIES PRIVATE LIMITED</p>
              </div>
              <div className="contact-form">
                <h3>Any Questions or remarks? Just write us a message</h3>
                <p>
                  By submitting your contact information, you have granted
                  Zoplar explicit permission to contact you in the future
                  through calls, SMS, and emails to provide information about
                  our products.
                </p>

                <form onSubmit={handleContactUsSubmit}>
                  <div className="basic-form-ContactUs">
                    <input
                      type="text"
                      className="form-name-contactus"
                      name="fnameContactUs"
                      placeholder="Name"
                      onChange={handleContactUsInputChange}
                      required
                    ></input>
                    {phoneError && (
                      <p
                        className="phone-error"
                        style={{
                          top: "51%",
                          fontSize: "0.8vw",
                          color: "white",
                        }}
                      >
                        *Number should start from 6,7,8 or 9
                      </p>
                    )}
                    <input
                      className="mobile-number2"
                      type="number"
                      name="mobileNumberContactUs"
                      placeholder="Mobile number"
                      onChange={handleContactUsInputChange}
                      required
                    ></input>

                    <input
                      className="form-email"
                      type="text"
                      name="emailContactUs"
                      placeholder="Email"
                      onChange={handleContactUsInputChange}
                    ></input>

                    <input
                      type="text"
                      className="form-city"
                      name="cityContactUs"
                      placeholder="City"
                      onChange={handleContactUsInputChange}
                      required
                    ></input>

                    <textarea
                      className="ContactUs-info"
                      type="text"
                      name="ContactUsInfo"
                      placeholder="Write your query/ question here"
                      rows="4"
                      onChange={handleContactUsInputChange}
                    ></textarea>
                    <div>
                      <button
                        type="submit"
                        disabled={!isContactFormValid}
                        className={
                          isContactFormValid
                            ? "contact-us-active-sell"
                            : "contact-us-disabled-sell"
                        }
                      >
                        {" "}
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="phone-contact-form">
              <h3>Any Questions or remarks?</h3>
              <p>Just write us a message</p>
              <form onSubmit={handleContactUsSubmit}>
                <div className="basic-form-ContactUs">
                  <input
                    type="text"
                    className="form-name-contactus"
                    name="fnameContactUs"
                    placeholder="Name"
                    onChange={handleContactUsInputChange}
                    required
                  ></input>

                  <input
                    className="mobile-number2"
                    type="number"
                    name="mobileNumberContactUs"
                    placeholder="Mobile Number"
                    onChange={handleContactUsInputChange}
                    required
                  ></input>
                  {phoneError && (
                    <p className="phone-error-contact">
                      *Number should start from 6,7,8 or 9
                    </p>
                  )}
                  <input
                    style={{ marginTop: phoneError ? "5%" : "" }}
                    className="form-email"
                    type="text"
                    name="emailContactUs"
                    placeholder="Email ID"
                    onChange={handleContactUsInputChange}
                  ></input>

                  <input
                    type="text"
                    className="form-city"
                    name="cityContactUs"
                    placeholder="City Name"
                    onChange={handleContactUsInputChange}
                  ></input>

                  <textarea
                    className="ContactUs-info"
                    type="text"
                    name="ContactUsInfo"
                    placeholder="Write your query/ question here"
                    rows="4"
                    onChange={handleContactUsInputChange}
                  ></textarea>

                  <div>
                    <button
                      type="submit"
                      disabled={!isContactFormValid}
                      className={
                        isContactFormValid
                          ? "active-contactus"
                          : "disabled-contactus"
                      }
                    >
                      {" "}
                      Submit
                    </button>
                  </div>
                </div>
              </form>
              <div className="phonepermission">
                <p>
                  By submitting your contact information, you have granted
                  Zoplar explicit permission to contact you in the future
                  through calls, SMS, and emails to provide information about
                  our products.
                </p>
              </div>
            </div>

            <div className="zoplar-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.5624182667366!2d77.05639997502531!3d28.4022816945002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d2335a47c17dd%3A0xeadf18964217e739!2sZoplar%20Corporate%20Office!5e0!3m2!1sen!2sin!4v1696837085085!5m2!1sen!2sin"
                width="100%"
                title="zoplar-map"
                height="100%"
                style={{ border: "0" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ContactUs;
